/** RGB channels 0–255. */
export type Rgb = readonly [number, number, number];

/**
 * Colors of the dark "Seu app" card (HOME-09), the brand's navy gradient.
 * The card's styles are built from these values, and its spec measures every
 * text against the lightest point of the gradient (≥ 4.5:1). The highlight
 * is softer than the mockup's (0.85) so the 86% white text passes there.
 */
export const APP_CARD_PALETTE = {
  base: {
    /** Linear gradient, top → 82%. */
    lightest: [11, 52, 140] as Rgb, // #0B348C
    darkest: [21, 25, 30] as Rgb, // #15191E
  },
  /** Radial highlight at the top right. */
  highlight: { rgb: [21, 93, 252] as Rgb, alpha: 0.55 },
  /** Radial glow at the bottom left. */
  glow: { rgb: [21, 93, 252] as Rgb, alpha: 0.3 },
  /** White text opacity. */
  text: { primary: 1, secondary: 0.86 },
  /** White fill opacity of the boxes text sits on. */
  surfaces: { chip: 0.14, tile: 0.08, button: 0.06 },
} as const;

const rgba = ([r, g, b]: Rgb, alpha: number) => `rgba(${r},${g},${b},${alpha})`;
const rgb = ([r, g, b]: Rgb) => `rgb(${r},${g},${b})`;

const p = APP_CARD_PALETTE;

export const APP_CARD_BACKGROUND = [
  `radial-gradient(70% 60% at 90% 0%, ${rgba(p.highlight.rgb, p.highlight.alpha)}, ${rgba(p.highlight.rgb, 0)} 70%)`,
  `radial-gradient(60% 50% at 0% 100%, ${rgba(p.glow.rgb, p.glow.alpha)}, ${rgba(p.glow.rgb, 0)} 70%)`,
  `linear-gradient(165deg, ${rgb(p.base.lightest)} 0%, ${rgb(p.base.darkest)} 82%)`,
].join(', ');

export const appCardWhite = (alpha: number) => `rgba(255,255,255,${alpha})`;
